import { vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e6e2ed3c")

_pushScopeId("data-v-e6e2ed3c")
const _hoisted_1 = { id: "checkCompSettings" }
const _hoisted_2 = { class: "settings-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Show negative component", -1)
const _hoisted_4 = { class: "settings-row" }
const _hoisted_5 = { class: "input-box" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "Check-Type", -1)
const _hoisted_7 = { class: "settings-row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "settings-row" }, [
  /*#__PURE__*/_createVNode("p", null, " The Check-Component is a Group-Component that can contain two components. The first one will be visible if the check passes and the second one when not. ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.component.drawNegative = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.component.drawNegative]
      ]),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("select", {
          value: _ctx.component.check.name,
          onChange: _cache[2] || (_cache[2] = $event => (_ctx.component.check = _ctx.checks[$event.target.value].generator()))
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.checkIDs, (checkType) => {
            return (_openBlock(), _createBlock("option", {
              key: checkType,
              value: checkType
            }, _toDisplayString(checkType), 9, ["value"]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 40, ["value"]),
        _hoisted_6
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.checks[_ctx.component.check.name].component), {
        action: _ctx.component.check
      }, null, 8, ["action"]))
    ]),
    _hoisted_8
  ]))
})